import { createContext } from 'react';

export type UpdateFlinksCtx = {
  showUpdateSuccessAlert: boolean;
  showUpdateErrorAlert: boolean;
  UpdateError: string;
};

const UpdateFlinks = createContext<UpdateFlinksCtx>({
  showUpdateSuccessAlert: false,
  showUpdateErrorAlert: false,
  UpdateError: '',
});

export default UpdateFlinks;
